import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Output } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { environment } from './../../../../../environments/environment';

@Injectable()
export class ProductCategoryUpdateStatusService {
    private urlPrefix: string = environment.appUrl;
    constructor(
        private http: Http,
        private httpClient: HttpClient
    ) {}

    update(id): Observable<any> {
        const url = this.urlPrefix + 'product-cats/' + id + '/update-status';
        return this.httpClient
            .put(url, {
            }, {
                observe: 'response'
            })
            .map(
                res => {
                    if (res.status === 200) {
                        return res.body;
                    } else {
                        return Observable.throw(null);
                    }
                }
            )
            .catch(
                err => {
                    return Observable.throw(err);
                }
            );
    }
}



// WEBPACK FOOTER //
// /Users/adminuser/Documents/pentagon/pentagon-admin/src/app/views/home/product-category/detail/update-status.service.ts